export default __webpack_public_path__ + "static/media/kitchen4-afterF-1440w.7e2c4a2f.avif";